// this is used to ensure that things like field names are strongly typed
export function nameof<T>(key: keyof T): keyof T {
    return key;
}

export const createMarkup = (html: string) => {
    // this space is used to add an empty text node at the start of snippets
    // this is required for highlighting to work
    return { __html: " " + html };
};

// changes ["one", "two", "three"] to "one, two and three"
export const arrayToStringWithCommasAnd = (arr: Array<string>) => {
    if (arr.length === 1) {
        return arr[0];
    }
    const firsts = arr.slice(0, arr.length - 1);
    const last = arr[arr.length - 1];
    return firsts.join(", ") + " and " + last;
};

// shuffles an array
export const shuffle = (a: Array<any>) => {
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
};